export default __webpack_public_path__ + "static/media/MainImage.9d72a516.png";